/*
    Zoom in/out
*/

export default function zoomIn(vue){

    let view = vue.$route.name;
  let screensaver = document.getElementById("screensaver");

    //if not on the screensaver view, zoom in
    if(view != 'screensaver'){

        screensaver.classList.add('zoom');

        //keep the animation by removing the background if deep routing
        if(view != 'discover'){

            screensaver.classList.add('fadeOut');

        }else{
            screensaver.classList.remove('fadeOut');
        }

    }else{

        screensaver.classList.remove('zoom');

        screensaver.classList.remove('fadeOut');

    }

}



// WEBPACK FOOTER //
// ./src/functions/zoom.js